"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Mon Nov 12 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowItemUpdateDTOConverter.
 *
 * @author JMt
 */


var WindowItemUpdateDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowItemUpdateDTOConverter, _DataObjectConverter_);

  function WindowItemUpdateDTOConverter() {
    _classCallCheck(this, WindowItemUpdateDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemUpdateDTOConverter).apply(this, arguments));
  }

  return WindowItemUpdateDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowItemUpdateDTOConverter = WindowItemUpdateDTOConverter;